import { Button, Card, H5 } from "@blueprintjs/core";
import React, { useCallback, useState } from "react";
import ReactJson from "react-json-view";
import PolicyDialog from "components/policies/PolicyDialog";
import PolicyGrid from "components/policies/PolicyGrid";
import PolicyMenu from "components/policies/PolicyMenu";
import Splitter from "components/Splitter";
import { AlarmPolicy } from "types";

export default function PolicyPage() {
    const [policy, setPolicy] = useState<AlarmPolicy>();
    const [isOpen, setIsOpen] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const toggle = useCallback(
        (isEditing?: boolean, policy?: AlarmPolicy) => {
            if (isEditing) {
                console.log("setting policy");
                setIsEdit(true);
                setPolicy(policy);
            } else {
                setIsEdit(false);
            }
            setIsOpen(!isOpen);
        },
        [isOpen]
    );
    return (
        <div className="main-container">
            <PolicyDialog toggle={toggle} isOpen={isOpen} isEdit={isEdit} policy={policy} />

            <PolicyMenu
                page="policies"
                actions={[<Button icon="new-object" text="New" intent="primary" onClick={() => toggle()} />]}
            />
            <div className="splitter-container">
                <Splitter
                    primaryFraction={40}
                    primary={
                        <div className="grid-container">
                            <div className="ag-theme-balham-dark ag">
                                <PolicyGrid setPolicy={setPolicy} toggle={toggle} />
                            </div>
                        </div>
                    }
                    secondary={
                        <div className="secondary-card">
                            <Card className="json-viewer">
                                <H5 className="json-header">{policy ? policy.id : "Please Select a Policy to View"}</H5>
                                {policy && (
                                    <ReactJson
                                        name="job"
                                        src={policy}
                                        style={{
                                            textAlign: "left",
                                            fontSize: "1rem",
                                            wordBreak: "break-all"
                                        }}
                                        displayDataTypes={false}
                                        displayObjectSize={false}
                                        // enableClipboard={false}
                                        theme="ashes"
                                        iconStyle="square"
                                    />
                                )}
                            </Card>
                        </div>
                    }
                />
            </div>
        </div>
    );
}
